import {createSlice} from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const dispatchersAdapter = getAdapter({idFieldName: 'id'} );

const dispatchersSlice = createSlice({
    name: 'dispatchers',
    initialState: dispatchersAdapter.getInitialState(),
    reducers: {
        setDispatchers: (state, {payload: {dispatchers}}) => {
            dispatchersAdapter.setAll(state, dispatchers);
        }
    }
});

const selectors = dispatchersAdapter.getSelectors(({dispatchers}) => dispatchers);

export const getDispatchers = state =>  selectors.selectAll(state);

export const {setDispatchers} = dispatchersSlice.actions;
export default dispatchersSlice.reducer;